<template>
  <hb-basic-page
      :action-buttons="actionButtons"
      :back-button="{ show: true, fallback: 'message_center' }"
      :loading="loading"
      :subtle-loading="subtleLoading"
      :title="message.id ? $t('message_center.edit') : $t('message_center.create')"
      name="edit-message-center-view"
  >

    <v-col v-if="!loading" class="mb-10 " cols="12" lg="10" md="12" offset-lg="1" offset-md="0" offset-xl="1" xl="10">
      <v-row>
        <v-col>
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <SectionHeader>
                  {{ $tc('message_center.message', 1) }}
                </SectionHeader>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <div class="mb-5">
                          <strong>{{ $t('message_center.basic_details') }}</strong>
                        </div>
                        <v-autocomplete v-model="message.category" :items="categories"
                                        :label="$t('message_center.category')"
                                        :rules="[$rules.required]" hide-details/>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field v-model="message.author" :label="$t('message_center.author')"
                                      :rules="[$rules.required]"/>
                      </v-col>

                      <v-col cols="12">
                        <div class="mb-5">
                          <strong>{{ $tc('message_center.message', 1) }}</strong>
                        </div>
                        <v-text-field v-model="message.title" :label="$t('message_center.title_field')"
                                      :rules="[$rules.required]" hide-details/>
                      </v-col>
                      <v-col cols="6">
                        <v-textarea auto-grow v-model="message.message" :label="$tc('message_center.message',1)"
                                    :rules="[$rules.required]" hide-details class="message-textarea"/>

                        <br/>
                        <a href="https://adapttive.github.io/vue-markdown/"
                           target="_blank">{{ $t('message_center.markdown_guide') }}</a>
                      </v-col>
                      <v-col cols="6">
                        <div class="mb-5">
                          <strong>{{ $t('message_center.message_preview') }}</strong>
                        </div>
                        <vue-markdown class="vue-markdown" :source="message.message"></vue-markdown>
                      </v-col>
                      <v-col cols="12">

                      </v-col>
                      <v-col cols="12">
                        <div class="mb-5">
                          <strong>{{ $t('message_center.publish_settings') }}</strong>
                        </div>
                        <v-switch v-model="message.published" :label="$t('message_center.published')" persistent-hint
                                  :hint="$t('message_center.published_help')"/>
                      </v-col>
                      <v-col cols="12">
                        <v-switch v-model="message.sticky" :label="$t('message_center.sticky')" persistent-hint
                                  :hint="$t('message_center.sticky_help')"/>
                      </v-col>

                    </v-row>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-form>

        </v-col>
      </v-row>


    </v-col>


    <template v-if="validationErrors" v-slot:bottom-bar-help>
        <span class="caption">
          <v-icon color="error" size="20" style="margin-top: -2px;">mdi mdi-alert</v-icon>
          {{ $t('message_center.errors.validation_errors') }}
        </span>
    </template>

  </hb-basic-page>
</template>

<script>
import SectionHeader from "@/components/SectionHeader";
import messagecenterApi from "@/api/messagecenter";
import VueMarkdown from '@adapttive/vue-markdown'

export default {
  name: 'EditMessageCenterView',
  components: {SectionHeader, VueMarkdown},
  data() {
    return {
      loading: true,
      subtleLoading: false,
      tab: null,

      typeError: false,
      datesError: false,
      validationErrors: false,

      message: {
        id: null,
        title: '',
        message: '',
        category: 'release_notes',
        published: false,
        sticky: false,
        author: '',
      },
      actionButtons: {
        cancel: {
          text: this.$t('cancel'),
          icon: 'arrow_back',
          callback: this.cancel,
          primary: false,
        },
        save: {
          text: this.$t('save'),
          icon: 'mdi mdi-check',
          callback: this.saveMessage,
          primary: true,
          loading: false,
        },
      }
    };
  },
  computed: {
    categories() {
      return messagecenterApi.getCategories();
    }
  },
  methods: {
    async saveMessage() {


      this.typeError = false;
      this.datesError = false;
      this.validationErrors = false;


      if (!this.$refs.form.validate()) {
        this.validationErrors = true;
      }

      if (this.validationErrors) {
        this.actionButtons.save.loading = false;
        this.actionButtons.cancel.disabled = false;
        return;
      }
      this.actionButtons.save.loading = true;
      this.actionButtons.cancel.disabled = true;

      try {
        if (!this.message.id) {
          const s = await messagecenterApi.createMessage(this.message);
          this.$showSuccessNotification(this.$t('message_center.messages.saved'));
          this.$router.replace({name: 'edit_messagecenter_message', params: {id: s.id}});
        } else {
          const s = await messagecenterApi.updateMessage(this.message.id, this.message);
          this.message = s;
          this.$showSuccessNotification(this.$t('message_center.messages.saved'));
          //this.$router.replace({name: 'edit_messagecenter_message', params: {id: s.id}});
        }
      } catch (e) {
        this.$handleApiError(e, this.$t('message_center.errors.error_saving'))
      }

      this.actionButtons.save.loading = false;
      this.actionButtons.cancel.disabled = false;
    },
    cancel() {
      this.$router.go(-1);
    },
    async getMessage() {
      this.loading = true;
      try {
        this.message = await messagecenterApi.getMessage(this.$route.params.id);

      } catch (e) {
        this.$handleApiError(e, this.$t('errors.error_loading_surveytemplate'))
      }
      this.loading = false;
    }


  },
  async mounted() {
    if (!this.$hasMatchingRoles(['admin'])) {
      this.$router.replace({name: 'access_denied'});
      return;
    }
    this.loading = false;
    this.message.author = [this.$userInfo?.firstName, this.$userInfo?.lastName].filter(Boolean).join(' ');
    if (this.$route.params.id) {
      await this.getMessage();
    }
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  border-bottom: 2px solid var(--v-primary-base) !important;
}

.empty-spacer {
  height: 800px;
}


</style>

<style lang="scss">
.edit-message-center-view {
  .message-textarea {
    font-size: 0.775rem !important;

    textarea {
      line-height: 1rem !important;
    }
  }
}

</style>
